"use strict";
/**
 * A function that takes a string and returns a set of avatar letters using our
 * standard algorithm.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToAvatarLetters = exports.normalizeNameArray = void 0;
const normalizeNameArray = (str) => str
    .replace(/ *\([^)]*\) */g, "") // Remove everything with parenthesis. "Some long name (admin)"" => "Some long name"
    .split(/\s/) // Split the name on space. Joakim Tørmoen => ["Joakim", "Tørmoen"]
    // Maker sure we have no empty values
    .filter(Boolean);
exports.normalizeNameArray = normalizeNameArray;
/**
 * Transforms a given string into a set of initials based on our standard.
 *
 * @param {string} str - The string to transform into initials.
 * @param {TStringToAvatarLettersOpts} [opts] - Optional settings, including max number of characters to include.
 * @returns {string} The generated initials, up to the specified maximum characters, uppercase.
 */
const stringToAvatarLetters = (str, opts) => {
    const { maxChars = 2 } = opts || {};
    const normalizedArray = (0, exports.normalizeNameArray)(str);
    if (maxChars === 1) {
        // If we only ask for 1 character we chose the first character of the string
        return normalizedArray[0].charAt(0).toUpperCase();
    }
    /**
     * For everything else we will:
     * - Pick out the first character of the first string
     * - Pick out the first character of the last string. This will make "Problematic von Avatar" => PA
     * - If we have more then 2 characters, start from the 2nd item and walk back
     */
    return normalizedArray
        .filter((_localStr, idx) => {
        if (idx === 0 || idx == normalizedArray.length - 1) {
            // Keep the first and the last
            return true;
        }
        //maxChars is > 2, so we need to allow maxChars - 2 additional chars
        return idx <= maxChars - 2;
    })
        .map((s) => s.charAt(0).toUpperCase()) // Pick out the first letter of the remaining items and make them uppercase
        .join("");
};
exports.stringToAvatarLetters = stringToAvatarLetters;
